import useFormattedDate from "hooks/useFormatDate";
import React from "react";
import { Card, Image } from "react-bootstrap";
import placeholderPhoto from "assets/img/profileplaceholder.png"
import SubtleBadge from "components/common/SubtleBadge";
import CopyableText from "components/common/CopyableText";

export default function ProfileSummary({ profile, handlePreviewClick }) {
  const { formatDate } = useFormattedDate();
  if (!profile) return null;

  return (
    <Card className="custom-shadow border-0 sticky-top" style={{ top: 90 }}>
      <Card.Body className="text-center">
        <Image
          src={profile.profilePhoto || placeholderPhoto}
          roundedCircle
          width={120}
          height={120}
          className="mb-3"
          onClick={() => handlePreviewClick(profile.profilePhoto)}
        />

        <h5 className="fw-semibold mb-1">
          {profile.firstName} {profile.lastName}
        </h5>
        <small className="text-muted">{profile.email}</small>

        <div className="mt-3">
          <SubtleBadge bg={profile.status === "ACTIVE" ? "success" : "warning"}>
            {profile.status}
          </SubtleBadge>
        </div>

        <hr />
        <small className="text-muted d-block">
          DOB: {formatDate(profile.birthDate)}
        </small>
        <small className="text-muted d-block">
          User ID: <CopyableText value={profile.id} />
        </small>
      </Card.Body>
    </Card>
  );
}
